import { connect } from 'react-redux';
import AuctionHistoryGrid from 'components/auctions/AuctionHistoryGrid';
import {
  fetchAuctionHistory,
  clearAuctionHistory,
} from 'data/auctions/Auctions.actions';

const mapStateToProps = (state, ownProps) => {
  return {
    data: state.auctions.partPriceHistory,
    error: state.auctions.partPriceHistoryError,
    fetching: state.auctions.fetchingPartPriceHistory,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchData: auctionId => dispatch(fetchAuctionHistory(auctionId)),
    clearData: () => dispatch(clearAuctionHistory()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AuctionHistoryGrid);
